export const CONTACTS_ADD_ITEM = "CONTACTS_ADD_ITEM";
export const GET_ALL_CONTACTS = "GET_ALL_CONTACTS";
export const CONTACTS_UPDATE_ITEM = "CONTACTS_UPDATE_ITEM";
export const DELETE_CONTACT_ITEM = "DELETE_CONTACT_ITEM";
export const IMPORT_CONTACTS = "IMPORT_CONTACTS";
export const SEND_MESSAGE = "SEND_MESSAGE"